<template>
    <div class="flex flex-col grow justify-center">
        <div class="flex flex-wrap">
            <form-field-wrapper
                label="Store Name"
                :error="form.errors.get('name')"
                :should-show-error="form.errors.has('name')"
            >
                <input
                    id="store-name"
                    v-model="form.name"
                    class="form-field"
                    type="text"
                    placeholder="Enter the name of your gift registry store"
                >
            </form-field-wrapper>

            <form-field-wrapper
                label="Registry URL"
                :error="form.errors.get('url')"
                :should-show-error="form.errors.has('url')"
            >
                <input
                    id="store-url"
                    v-model="form.url"
                    class="form-field"
                    type="text"
                    placeholder="The link to your online gift registry"
                >
            </form-field-wrapper>

            <form-field-wrapper label="Image or Logo">
                <image-manager
                    v-model="form.images"
                    :max-images="1"
                    :settings="{}"
                    title="Upload Image or Logo"
                    uploader-classes="text-left"
                ></image-manager>
            </form-field-wrapper>

            <portal to="app-drawer-footer">
                <footer-save-cancel
                    :processing="loading"
                    @cancel="$emit('cancel')"
                    @save="save"
                ></footer-save-cancel>
            </portal>
        </div>
    </div>
</template>

<script>
import WallItemSettingsMixin from '@/mixins/WallItemSettingsMixin';

export default {
    name: 'WallGiftRegistryBlockItemSettings',

    mixins: [WallItemSettingsMixin]
};
</script>
